import { render, staticRenderFns } from "./addRoleConfig.vue?vue&type=template&id=3cba4314&scoped=true"
import script from "./addRoleConfig.vue?vue&type=script&lang=js"
export * from "./addRoleConfig.vue?vue&type=script&lang=js"
import style0 from "./addRoleConfig.vue?vue&type=style&index=0&id=3cba4314&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cba4314",
  null
  
)

export default component.exports